// голосовалка «ваше отношение к аромату»
import { addGlobalLiveEventListener } from "../../utils";
import { hidePreloader, showPreloader } from "../../components/preloader";
import ajax from "../../components/ajax";
function onClick() {
    showPreloader();
    ajax('/ajax/votes.php', { element_id: this.dataset.id, val: this.dataset.val })
        .then(response => response.text())
        .then(data => {
        document.querySelector('.vote_block').outerHTML = data;
        hidePreloader();
    });
}
export default function initAromaVote() {
    addGlobalLiveEventListener('click', '.item_vote', onClick);
}
